var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.showTemplate === 0,
          expression: "showTemplate === 0",
        },
      ],
      staticClass: "manager-container",
    },
    [
      _vm.showTemplate === 2
        ? _c("edit-automatic-schedule", {
            attrs: {
              "job-data": _vm.currentContract,
              mpaTransactionData: _vm.mpaTransactionData,
              hasSysAdminPermission: _vm.hasSysAdminPermission,
              locationOptionProps: _vm.locationOptionProps,
              availableBargesOptions: _vm.availableBargesOptions,
              availableBargesLoading: _vm.availableBargesLoading,
              sgTradexState: _vm.sgTradexState,
            },
            on: {
              close: _vm.closeDetail,
              checkAvailableBargesOptions: _vm.visibleChange,
              "update:sgTradexState": function ($event) {
                _vm.sgTradexState = $event
              },
              "update:sg-tradex-state": function ($event) {
                _vm.sgTradexState = $event
              },
              onClearInterval: _vm.onClearInterval,
            },
          })
        : _vm._e(),
      _vm.showTemplate === "loading"
        ? _c("handle-exwharf-schedule", {
            attrs: {
              "job-data": _vm.currentContract,
              mpaTransactionData: _vm.mpaTransactionData,
              currentCompanyShips: _vm.currentCompanyShips,
              locationOptionProps: _vm.locationOptionProps,
            },
            on: {
              close: _vm.closeDetail,
              "refresh-company-ships": _vm.getShipsByCompany,
            },
          })
        : _vm._e(),
      _vm.showTemplate === "delivery"
        ? _c("handle-delivered-schedule", {
            attrs: {
              "job-data": _vm.currentContract,
              mpaTransactionData: _vm.mpaTransactionData,
              hasSysAdminPermission: _vm.hasSysAdminPermission,
              locationOptionProps: _vm.locationOptionProps,
              sgTradexState: _vm.sgTradexState,
            },
            on: {
              "update:sgTradexState": function ($event) {
                _vm.sgTradexState = $event
              },
              "update:sg-tradex-state": function ($event) {
                _vm.sgTradexState = $event
              },
              close: _vm.closeDetail,
              onClearInterval: _vm.onClearInterval,
            },
          })
        : _vm._e(),
      _vm.showTemplate === "sts"
        ? _c("handle-internal-transfer", {
            attrs: {
              "job-data": _vm.currentContract,
              mpaTransactionData: _vm.mpaTransactionData,
              hasSysAdminPermission: _vm.hasSysAdminPermission,
              locationOptionProps: _vm.locationOptionProps,
              sgTradexState: _vm.sgTradexState,
              currentCompanyShips: _vm.currentCompanyShips,
            },
            on: {
              close: _vm.closeDetail,
              "update:sgTradexState": function ($event) {
                _vm.sgTradexState = $event
              },
              "update:sg-tradex-state": function ($event) {
                _vm.sgTradexState = $event
              },
              onClearInterval: _vm.onClearInterval,
              "refresh-company-ships": _vm.getShipsByCompany,
            },
          })
        : _vm._e(),
      _vm.showTemplate === 1
        ? [
            _c("div", { staticClass: "flex-between-row" }, [
              _c("h1", { staticClass: "div-main-view-title" }, [
                _vm._v(_vm._s(_vm.orderType)),
              ]),
            ]),
            _c(
              "el-row",
              {
                class: _vm.isFilterVisit
                  ? " shadow-border-bottom handler-bar"
                  : "handler-bar",
                attrs: { gutter: 25, align: "middle" },
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: _vm.isMobileScreen ? 24 : 10 } },
                  [
                    _c(
                      "el-tabs",
                      {
                        on: {
                          "tab-click": function ($event) {
                            return _vm.getJobTableData()
                          },
                        },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      _vm._l(_vm.statusTabs, function (item, index) {
                        return _c("el-tab-pane", {
                          key: item.name,
                          attrs: { label: item.name, name: index.toString() },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.isMobileScreen ? 24 : 14 } },
                  [
                    _c("div", { staticClass: "button-block" }, [
                      !_vm.isMobileScreen
                        ? _c("div", { staticClass: "query-item filter-btn" }, [
                            _c(
                              "span",
                              {
                                class: !_vm.showCustomiseListDialog
                                  ? "span-btn-primay"
                                  : "span-btn-active",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCustomiseListDialog()
                                  },
                                },
                              },
                              [_vm._v(" Customise List ")]
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "query-item filter-btn" }, [
                        _c(
                          "span",
                          {
                            class: !_vm.isFilterVisit
                              ? "span-btn-primay"
                              : "span-btn-active",
                            on: { click: _vm.handleClickFilter },
                          },
                          [_vm._v(" Filter ")]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "query-item search-bar" },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "round-input",
                              attrs: {
                                size: _vm.isMobileScreen ? "mini" : "default",
                                placeholder:
                                  "Search By Job id, Barge, Vessel or Terminal",
                              },
                              nativeOn: {
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getJobTableData()
                                },
                              },
                              model: {
                                value: _vm.jobSearchVal,
                                callback: function ($$v) {
                                  _vm.jobSearchVal = $$v
                                },
                                expression: "jobSearchVal",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  type: "primary",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getJobTableData()
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "query-item create-btn" },
                        [
                          _vm.hasPermission(_vm.$permissionFunctionCode.ADD)
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: _vm.isMobileScreen ? "mini" : "small",
                                    round: "",
                                    type: "primary",
                                    loading: _vm.createNewScheduleLoading,
                                  },
                                  on: { click: _vm.createNewSchedule },
                                },
                                [
                                  _vm.isMobileScreen
                                    ? _c("span", [_vm._v("+")])
                                    : _c("span", [
                                        _vm._v(_vm._s(_vm.$t("Create Job"))),
                                      ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.isMaersk
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: _vm.isMobileScreen ? "mini" : "small",
                                    round: "",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.uploadJobDialogVisible = true
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      alt: "img",
                                      src: require("@/assets/icons/excel-icon.png"),
                                      width: "10",
                                    },
                                  }),
                                  _vm._v(" Import Job "),
                                ]
                              )
                            : _vm._e(),
                          false
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: _vm.isMobileScreen ? "mini" : "small",
                                    round: "",
                                    type: "primary",
                                  },
                                  on: { click: _vm.handleDownloadJob },
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-download",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticStyle: { margin: "0px 0px 0px 10px" } },
                            [
                              _c("dropdown-action-menu", {
                                staticClass: "dropdown-action-menu",
                                attrs: {
                                  actionList: _vm.getJobTableMenuList(),
                                },
                                on: {
                                  handleDropdownMenuClick:
                                    _vm.handleJobDropdownMenuClick,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm.isFilterVisit
              ? _c(
                  "el-row",
                  {
                    staticClass: "handler-bar",
                    staticStyle: { margin: "5px 0" },
                    attrs: { gutter: 5, align: "middle" },
                  },
                  [
                    _c(
                      "el-col",
                      {
                        class: {
                          "filter-line-mobile": _vm.isMobileScreen,
                          "filter-line": !_vm.isMobileScreen,
                        },
                        attrs: { span: 20 },
                      },
                      [
                        [
                          _vm.isMobileScreen
                            ? _c("span", { staticClass: "label-mobile" }, [
                                _vm._v("Job Type:"),
                              ])
                            : _vm._e(),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: _vm.isMobileScreen ? "mini" : "small",
                                placeholder: "Select a Job Type",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getJobTableData()
                                },
                              },
                              model: {
                                value: _vm.jobFilter.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.jobFilter, "type", $$v)
                                },
                                expression: "jobFilter.type",
                              },
                            },
                            _vm._l(_vm.jobOpts, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        [
                          _vm.isMobileScreen
                            ? _c("span", { staticClass: "label-mobile" }, [
                                _vm._v("Contract Type:"),
                              ])
                            : _vm._e(),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: _vm.isMobileScreen ? "mini" : "small",
                                placeholder: "Select a Contract Type",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getJobTableData()
                                },
                              },
                              model: {
                                value: _vm.jobFilter.termContractType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.jobFilter,
                                    "termContractType",
                                    $$v
                                  )
                                },
                                expression: "jobFilter.termContractType",
                              },
                            },
                            _vm._l(_vm.termContractTypeOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        [
                          _vm.isMobileScreen
                            ? _c("span", { staticClass: "label-mobile" }, [
                                _vm._v("Ship:"),
                              ])
                            : _vm._e(),
                          _c(
                            "el-select",
                            {
                              staticClass: "vessel-selector",
                              attrs: {
                                size: _vm.isMobileScreen ? "mini" : "small",
                                placeholder: "Select a Ship",
                              },
                              on: { change: _vm.handleSelectFilterShip },
                              model: {
                                value: _vm.jobFilter.bargeShipId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.jobFilter, "bargeShipId", $$v)
                                },
                                expression: "jobFilter.bargeShipId",
                              },
                            },
                            _vm._l(_vm.shipOptsByCompany, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        [
                          _vm.isMobileScreen
                            ? _c("span", { staticClass: "label-mobile" }, [
                                _vm._v("Company:"),
                              ])
                            : _vm._e(),
                          _c(
                            "el-select",
                            {
                              staticClass: "vessel-selector",
                              attrs: {
                                size: _vm.isMobileScreen ? "mini" : "small",
                                placeholder: "Select a Company",
                                loading: _vm.companyFiltersLoading,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getJobTableData()
                                },
                                "visible-change": function ($event) {
                                  return _vm.getCompanyFiltersOptions($event)
                                },
                              },
                              model: {
                                value: _vm.jobFilter.companyId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.jobFilter, "companyId", $$v)
                                },
                                expression: "jobFilter.companyId",
                              },
                            },
                            _vm._l(_vm.companyFiltersOptions, function (group) {
                              return _c(
                                "el-option-group",
                                {
                                  key: group.label,
                                  attrs: { label: group.label },
                                },
                                _vm._l(group.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        [
                          _vm.isMobileScreen
                            ? _c("span", { staticClass: "label-mobile" }, [
                                _vm._v("Date Range:"),
                              ])
                            : _vm._e(),
                          _c(
                            "span",
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: _vm.isMobileScreen ? "mini" : "small",
                                  type: "datetimerange",
                                  "range-separator": "to",
                                  "start-placeholder":
                                    "ETA/LoadingNom Start Date",
                                  "end-placeholder": "ETA/LoadingNom End Date",
                                  "popper-class": "custom-datetimerange",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.getJobTableData()
                                  },
                                },
                                model: {
                                  value: _vm.jobFilter.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.jobFilter, "date", $$v)
                                  },
                                  expression: "jobFilter.date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                      ],
                      2
                    ),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c(
                        "span",
                        {
                          staticClass: "span-btn-primay",
                          staticStyle: { float: "right", width: "50px" },
                          on: {
                            click: function ($event) {
                              return _vm.handleResetSearchQuery()
                            },
                          },
                        },
                        [_vm._v(" Reset ")]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "table-block margin-top-0",
                style: {
                  height: _vm.isFilterVisit
                    ? "calc(100% - 150px)"
                    : "calc(100% - 74px)",
                },
              },
              [
                _c("table-job", {
                  attrs: {
                    hasTableMenu: "",
                    hasPagination: "",
                    isJobTableLoading: _vm.isJobTableLoading,
                    availableBargesLoading: _vm.availableBargesLoading,
                    availableBargesOptions: _vm.availableBargesOptions,
                    jobTableData: _vm.jobTableData,
                    activeTab: +_vm.activeName,
                    jobPagination: _vm.jobPagination,
                    customiseListData: _vm.customiseListDataUI,
                  },
                  on: {
                    handleJobDropdownMenuClick: _vm.handleJobDropdownMenuClick,
                    handleJobPageChange: _vm.handleJobPageChange,
                    handleJobPageSizeChange: _vm.handleJobPageSizeChange,
                    checkAvailableBargesOptions: _vm.visibleChange,
                    handleJobTableRefresh: _vm.handleJobTableRefresh,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.contractTypeVisible
        ? _c("select-schedule-type", {
            on: {
              closed: function ($event) {
                _vm.contractTypeVisible = false
              },
              selected: _vm.selectedHandler,
            },
          })
        : _vm._e(),
      _vm.locationDialogVisible
        ? _c("add-terminal-and-berth", {
            on: {
              closed: function ($event) {
                _vm.locationDialogVisible = false
              },
            },
          })
        : _vm._e(),
      _c("file-preview-list", {
        attrs: { visible: _vm.attachmentsVisible, order: _vm.currentContract },
        on: {
          "update:visible": function ($event) {
            _vm.attachmentsVisible = $event
          },
        },
      }),
      _vm.blockchainInfoVisible
        ? _c("dialog-blockchain-info", {
            attrs: { propsData: _vm.blockchainData },
            on: { onClose: _vm.handleCloseBlockchainInfo },
          })
        : _vm._e(),
      _c("dialog-transfer-job", {
        attrs: {
          dialogTransferJob: _vm.dialogTransferJob,
          "job-data": _vm.currentContract,
          availableBargesLoading: _vm.availableBargesLoading,
          availableBargesOptions: _vm.availableBargesOptions,
        },
        on: {
          checkAvailableBargesOptions: _vm.visibleChange,
          handleTransferJobsDialogClose: function ($event) {
            _vm.dialogTransferJob = false
          },
          handleJobTableRefresh: _vm.handleJobTableRefresh,
        },
      }),
      _vm.addRecipientmailFormDialogVisible
        ? _c("AddRecipientEmail", {
            attrs: { entity: _vm.currentContract },
            on: {
              close: () => (_vm.addRecipientmailFormDialogVisible = false),
            },
          })
        : _vm._e(),
      _vm.uploadJobDialogVisible
        ? _c("UploadJob", {
            on: {
              success: () => _vm.getJobTableData(),
              close: () => (_vm.uploadJobDialogVisible = false),
            },
          })
        : _vm._e(),
      _vm.showTemplate === 4
        ? _c("ImportExcelLog", { on: { close: _vm.closeDetail } })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Export Job",
            visible: _vm.showExportJobDialog,
            width: _vm.isMobileScreen ? "100%" : "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportJobDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                          },
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                plain: "",
                                type: "primary",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showExportJobDialog = false
                                },
                              },
                            },
                            [_vm._v("Close")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.exportJobToExcel()
                                },
                              },
                            },
                            [_vm._v("Export")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "export-job-form" },
            [
              _c(
                "el-row",
                { attrs: { align: "left" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("Status:"),
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          staticClass: "status-checkbox-group",
                          model: {
                            value: _vm.exportJobFilter.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.exportJobFilter, "status", $$v)
                            },
                            expression: "exportJobFilter.status",
                          },
                        },
                        _vm._l(_vm.statusOptions, function (status) {
                          return _c(
                            "el-row",
                            { key: status.value },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: status.value } },
                                    [_vm._v(" " + _vm._s(status.label) + " ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { align: "middle" },
                },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("Data Range:"),
                  ]),
                  _c("el-col", { attrs: { span: 18 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "1px" },
                            attrs: { size: "mini", placeholder: "Select" },
                            model: {
                              value: _vm.exportJobFilter.dateType,
                              callback: function ($$v) {
                                _vm.$set(_vm.exportJobFilter, "dateType", $$v)
                              },
                              expression: "exportJobFilter.dateType",
                            },
                          },
                          _vm._l(_vm.exportDateTypes, function (option) {
                            return _c("el-option", {
                              key: option.value,
                              attrs: {
                                label: option.label,
                                value: option.value,
                              },
                            })
                          }),
                          1
                        ),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetimerange",
                            "unlink-panels": "",
                            "range-separator": "-",
                            "start-placeholder": "Start date",
                            "end-placeholder": "End date",
                            "picker-options": _vm.pickerOptions,
                            size: "mini",
                          },
                          model: {
                            value: _vm.exportJobFilter.dateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.exportJobFilter, "dateRange", $$v)
                            },
                            expression: "exportJobFilter.dateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { align: "middle" },
                },
                [
                  _c("el-col", { attrs: { span: 6 } }, [_vm._v("Barge Name:")]),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", clearable: "" },
                        model: {
                          value: _vm.exportJobFilter.bargeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.exportJobFilter, "bargeName", $$v)
                          },
                          expression: "exportJobFilter.bargeName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { align: "middle" },
                },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _vm._v("Vessel Name:"),
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", clearable: "" },
                        model: {
                          value: _vm.exportJobFilter.vesselName,
                          callback: function ($$v) {
                            _vm.$set(_vm.exportJobFilter, "vesselName", $$v)
                          },
                          expression: "exportJobFilter.vesselName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { margin: "10px 0px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [_vm._v(" ")]),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c("el-divider", [
                        _c("span", { staticStyle: { "margin-top": "10px" } }, [
                          _vm._v("OR"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { align: "middle" },
                },
                [
                  _c("el-col", { attrs: { span: 6 } }, [_vm._v("BDN Number:")]),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", clearable: "" },
                        model: {
                          value: _vm.exportJobFilter.bdnNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.exportJobFilter, "bdnNumber", $$v)
                          },
                          expression: "exportJobFilter.bdnNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCustomiseListDialog,
            top: "5vh",
            width: _vm.isMobileScreen ? "100%" : "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCustomiseListDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "space-between",
                        width: "100%",
                      },
                    },
                    [
                      _c("span", [_vm._v("Customise Operation List")]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "30px" },
                          attrs: { size: "mini" },
                          on: { click: _vm.toggleAllCheckboxes },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.allChecked ? "Uncheck All" : "Check All"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                          },
                          attrs: { span: 24 },
                        },
                        [
                          true
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    plain: "",
                                    type: "primary",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetCustomiseList()
                                    },
                                  },
                                },
                                [_vm._v("Default Sort")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                plain: "",
                                type: "primary",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showCustomiseListDialog = false
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveCustomiseList()
                                },
                              },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "draggable" },
            [
              _c(
                "el-table",
                {
                  key: _vm.customiseTableKey,
                  ref: "customiseRef",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.customiseListData,
                    id: "customiseListTable",
                    "row-class-name": "el-table__row__drag",
                    "row-key": "title",
                    border: "",
                    "table-layout": "auto",
                    height: "100%",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "No.", width: "50" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "Column", width: "250" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "show", label: "Show", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.sortable
                              ? _c(
                                  "div",
                                  [
                                    _c("el-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleColumnShow(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.show,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "show", $$v)
                                        },
                                        expression: "scope.row.show",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Drag", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.sortable
                              ? _c("div", { staticClass: "handle-drag" }, [
                                  _c("em", { staticClass: "el-icon-sort" }),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }